import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import SetupMenu from './SetupMenu';
import moment from "moment";
import Pagination from "../General/Pagination";
import { scrollToTop } from '../Shared/ScrollOnTop';

function ManageBankAccounts() {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [isUpdated, setIsUpdated] = useState(false);

    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {

        document.title = "Manage Bank Account";

        setIsUpdated(false);
        setLoading(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,

        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Setup/GetAllBanks',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
        //console.log(data)

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords || []);
                    setLoading(false);
                    setTotalRecords(response.data.totalRecords || 0);
                }
                else {
                    setLedger(null);
                    setTotalRecords(0)
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    setLoading(false);

                }

            })
            .catch(function (error) {
                toast.error('Network Error..', {
                    position: toast.POSITION.TOP_RIGHT
                });
            });

    }, [pageNo, pageSize, isUpdated]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const renderLedger = () => {

        if (listOfLedger != null && listOfLedger.length > 0) {
            let count = 1;
            let countbreak = 1;
            return (
                listOfLedger.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                {count++}
                            </td>
                            <td>{item.ID}</td>
                            <td>{item.Bank_Name}</td>
                            <td>{item.Bank_Address}</td>
                            <td>{item.Account_No}</td>
                            <td>{item.Fee_Voucher_Statement}</td>
                            <td>
                                <div className="form-check">
                                    <input
                                        key={item.Is_Default_Bank}
                                        data-type-id={item.Is_Default_Bank}
                                        className="form-check-input checkStudent"
                                        type="checkbox"
                                        value={item.Is_Default_Bank}
                                        checked={item.Is_Default_Bank}
                                    />
                                </div>
                            </td>
                            {item.Is_Delete_Able ?
                                <td>
                                    <ul className="inline-action" aria-labelledby="dropdownMenuButton1">
                                        <li><NavLink to={'/Setup/EditBankAcc/' + item.ID} className=" green"><i className="ri-edit-line"></i></NavLink></li>
                                        <li><button onClick={(e) => deleteBankAcc(item.ID)} className="red"><i className="ri-delete-bin-line"></i></button></li>
                                    </ul>
                                </td>
                                : <td></td>}
                        </tr>
                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colSpan="8"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }
    const deleteBankAcc = (ID) => {
        const confirm = window.confirm("Are you sure to proceed this action ?")

        if (confirm) {
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                ID: ID
            };

            var api_config = {
                method: 'post',
                url: config.base_url + '/Setup/DeleteBank',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            //console.log(data);
            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    if (response.data.status_code == 1) {
                        setIsUpdated(true);
                    }
                    // setIsUpdated(false);

                })
                .catch(function (error) {
                    //console.log(error);
                });
        }
    }

    return (
        <>
            <SetupMenu />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/Setup/SetupDashboard">Setup</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Manage Bank Accounts</li>
                                </ol>
                            </nav>
                            <div className="page-title">Manage Bank Accounts</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/SetUp/AddBankAcc" className="button button-white button-icon">
                                    Add Bank Account
                                    <i className="ri-add-line"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="card">
                        <div className="card-body table-wrap">
                            <div className="">


                                <table className="table table-theme table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                Sr#
                                            </th>
                                            <th>
                                                ID
                                            </th>
                                            <th>
                                                Bank Name
                                            </th>
                                            <th>
                                                Bank Address
                                            </th>
                                            <th>
                                                Account No
                                            </th>
                                            <th>
                                                Fee Voucher Statement
                                            </th>
                                            <th>
                                                Is Default Bank
                                            </th>
                                            <th className="text-center">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            loading ?
                                                <tr>
                                                    <td className="text-center" colSpan="7">
                                                        <Spinner animation="border" role="status"></Spinner>
                                                    </td>
                                                </tr>
                                                :
                                                <>
                                                    {renderLedger()}
                                                </>

                                        }
                                    </tbody>
                                </table>
                                {
                                    totalRecords > 10 &&
                                    <div className="pagination-wrap">

                                        <div className="row align-items-center">
                                            <div className="col-md-2 form_default">
                                                <div className="d-flex align-items-center">
                                                    <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                    <div className="form-group">
                                                        <select className="form-select"
                                                            style={{ width: "100px" }}
                                                            onChange={(e) => {
                                                                setPageNo(1);
                                                                setPageSize(parseInt(e.target.value));


                                                            }}>
                                                            <option value="10" selected>10</option>
                                                            <option value="20">20</option>
                                                            <option value="50">50</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <Pagination
                                                pageNo={pageNo}
                                                pageSize={pageSize}
                                                totalRecords={totalRecords}
                                                onPageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageBankAccounts;
